const Vue = require('vue')

Vue.component('ui-dropdown', {
    props: {
        clickProtection: {
            type: Boolean,
            default: null
        }
    },
    data () {
        return {
            attached: false
        }
    },
    ready () {
        this.$rootEl = this.$els.rootEl
        this.$buttonEl = this.$rootEl.querySelector('.toggler')
        this.$menuEl = this.$rootEl.querySelector('.dropdown-menu')

        this.$buttonEl.addEventListener('click', (event) => {
            this.show()
        })
    },
    beforeDestroy () {
        this.destroyEvent()
    },
    methods: {
        show () {
            if (this.attached) {
                return
            }

            this.attached = true
            this.$rootEl.classList.add('open')

            setTimeout(() => this.createEvent())
        },
        hide () {
            this.attached = false

            this.$rootEl.classList.remove('open')
            this.destroyEvent()
        },
        createEvent () {
            window.document.documentElement.addEventListener('click', this.bodyClicked)
        },
        destroyEvent () {
            window.document.documentElement.removeEventListener('click', this.bodyClicked)
        },
        bodyClicked (e) {
            if (this.clickProtection) {
                if (!this.$menuEl.contains(e.target)) {
                    this.hide()
                }
            } else {
                this.hide()
            }
        }
    },
    template: `
        <div class="dropdown" v-el:root-el>
            <slot></slot>
        </div>
    `
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/ui/dropdown.js